module.exports = __webpack_public_path__ + "files/0b5ea72f4bb0ee2a3a56f763ed3da913.png";